import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import KolorWheel from '../../utils/kolor-wheel.esm.js';

var generateColor = function generateColor(color1, color2) {
  var base = new KolorWheel(color1);
  var target = base.abs(color2, 10);
  return target.resultList.map(function (i) {
    return i.getHex();
  });
};
var baseColorPallets = ['red', 'orange', 'yellow', 'green', 'teal', 'blue', 'indigo', 'purple', 'pink'];
var baseColors = function baseColors() {
  var red = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['#FFB4B4', '#8A2100'];
  var orange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['#FFEAD4', '#ff7e00'];
  var yellow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['#FFFCD4', '#788D00'];
  var green = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['#EFFFD9', '#004900'];
  var teal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ['#E6FFFA', '#006161'];
  var blue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ['#e3ecff', '#130080'];
  var indigo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ['#FFDFFF', '#3C366B'];
  var purple = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : ['#FFF1FF', '#800080'];
  var pink = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : ['#FFF5F7', '#702459'];
  return {
    neutrals: ['#001122',
    //     0 cosmos black // base-black
    '#0c0c0c',
    //  1
    '#181818',
    //  2
    '#242424',
    //  3
    '#303030',
    //  4
    '#3c3c3c',
    //  5
    '#737c85',
    //  6 cosmos neutral darker // neutral-450
    '#555555',
    //  7
    '#616161',
    //  8
    '#6d6d6d',
    //  9
    '#797979',
    // 10
    '#8c949c',
    // 11 cosmos neutral dark  // neutral-350
    '#919191',
    // 12
    '#9d9d9d',
    // 13
    '#aaaaaa',
    // 14
    '#bfc4c8',
    // 15 cosmos neutral medium // neutral-250
    '#c2c2c2',
    // 16
    '#bfc4c8',
    // 17 cosmos neutral // neutral-250
    '#dadada',
    // 18
    '#e5e7e9',
    // 19 cosmos neutral light //  neutral-150
    '#f2f2f2',
    // 20
    '#f2f3f4',
    // 21 cosmos neutral lighter // neutral-100
    '#fcfdfd' // 22 // base-white
    ],
    primaries: ['#183969',
    // 0 cosmos secondary // blue-900
    '#0c3e78',
    // 1
    '#004487',
    // 2
    '#0054A6',
    // 3 cosmos primary // blue-700
    '#207ad8',
    // 4
    '#5CA7F3',
    // 5 cosmos primary medium  // blue-300
    '#e5eef6' //  6 cosmos primary light // blue-25
    ],
    successes: ['#017b30',
    // 0 cosmos green
    '#01b227',
    // 1
    '#01e90b',
    // 2
    '#41fe24',
    // 3
    '#8dff5b',
    // 4
    '#c6ff92',
    // 5
    '#ecffc9' // 6
    ],
    errors: ['#cf0201',
    // 0 cosmos red
    '#f60f02',
    // 1
    '#fc3a24',
    // 2
    '#fc664c',
    // 3
    '#fc8f74',
    // 4
    '#fcb39c',
    // 5
    '#ffbfbe' // 6
    ],
    alerts: ['#ec4a08',
    // 0 cosmos accent
    '#f75d1f',
    // 1
    '#f9753f',
    // 2
    '#fa8d60',
    // 3
    '#fba581',
    // 4
    '#fcbca2',
    // 5
    '#fdd4c3' // 6
    ],
    highlights: ['#ffb400',
    // 0 cosmos yellow
    '#ffbd1f',
    // 1
    '#ffc63e',
    // 2
    '#ffd05e',
    // 3
    '#ffd97d',
    // 4
    '#ffe29c',
    // 5
    '#ffebbb',
    // 6
    '#f28f20',
    // 7
    '#2186a5' // 8
    ],
    transparent: 'transparent',
    red: _toConsumableArray(generateColor(red[1], red[0])),
    orange: _toConsumableArray(generateColor(orange[1], orange[0])),
    yellow: _toConsumableArray(generateColor(yellow[1], yellow[0])),
    green: _toConsumableArray(generateColor(green[1], green[0])),
    teal: _toConsumableArray(generateColor(teal[1], teal[0])),
    blue: _toConsumableArray(generateColor(blue[1], blue[0])),
    indigo: _toConsumableArray(generateColor(indigo[1], indigo[0])),
    purple: _toConsumableArray(generateColor(purple[1], purple[0])),
    pink: _toConsumableArray(generateColor(pink[1], pink[0])),
    opaqueWhite: ['rgba(252, 253, 253, 0)', 'rgba(252, 253, 253, 0.1)', 'rgba(252, 253, 253, 0.2)', 'rgba(252, 253, 253, 0.3)', 'rgba(252, 253, 253, 0.4)', 'rgba(252, 253, 253, 0.5)', 'rgba(252, 253, 253, 0.6)', 'rgba(252, 253, 253, 0.7)', 'rgba(252, 253, 253, 0.8)', 'rgba(252, 253, 253, 0.9)', 'rgba(252, 253, 253, 1)'],
    opaqueBlack: ['rgba(0, 17, 34, 0)', 'rgba(0, 17, 34, 0.1)', 'rgba(0, 17, 34, 0.2)', 'rgba(0, 17, 34, 0.3)', 'rgba(0, 17, 34, 0.4)', 'rgba(0, 17, 34, 0.5)', 'rgba(0, 17, 34, 0.6)', 'rgba(0, 17, 34, 0.7)', 'rgba(0, 17, 34, 0.8)', 'rgba(0, 17, 34, 0.9)', 'rgba(0, 17, 34, 1)']
  };
};
var _baseColors = baseColors();

/** Add Cosmos tokens here **/
var colors = _objectSpread2({
  primary: {
    __default: '#0054A6',
    //    primaries.3   cosmos primary // blue-700
    light: '#e5eef6',
    //         primaries.6   cosmos primary light // blue-25
    medium: '#5ca7f3',
    //       primaries.5   cosmos primary medium // blue-300
    moderate: '#004487',
    // blue-800
    bold: '#0C3E78',
    // blue-850
    contrast: '#183969' // blue-900
  },
  secondary: {
    __default: '#183969',
    // primaries.0   cosmos secondary // blue-900
    dark: '#004487',
    // blue-850
    darker: '#0C3E78' // blue-800
  },
  neutral: {
    __default: '#bfc4c8',
    // neutrals.17 cosmos neutral // neutral-250
    subtlest: '#ecedef',
    // neutral-50 //
    subtler: '#d9dbde',
    // neutral-150 // disabled bg
    lighter: '#f2f3f4',
    // neutrals.21 cosmos neutral lighter  // neutral-25
    light: '#e5e7e9',
    // neutrals.19 cosmos neutral light  // neutral-100
    medium: '#bfc4c8',
    // neutrals.15 cosmos neutral medium  // neutral-250
    dark: '#8c949c',
    //  cosmos neutral dark  // neutral-550
    darker: '#737c85',
    // neutrals.6  cosmos neutral darker // neutral-450
    bold: '#a6aCb2',
    // neutrals.11 // neutral-350 // icons // action-neutral-rest
    contrast: '#33414e' // neutral-850
  },
  muted: '#e5e7e9',
  //          neutrals.21   cosmos neutral lighter // neutral-100
  accent: {
    __default: '#e33326',
    //    alerts.0 cosmos accent // red-500
    background: '#fdede6'
  },
  highlight18: '#bb8400',
  // Cosmos 2.0 colour - requires a defined token // yellow-600
  text: {
    __default: '#001122',
    //    neutrals.6    suite standard // base-black
    secondary: '#8c949c' //     cosmos neutral dark // tw: neutral-550
  },
  textSecondary: '#8c949c',
  //  neutrals.11   cosmos neutral dark // neutral-550
  'text-light-bg': '#001122',
  // base-black
  'text-dark-bg': '#fcfdfd',
  // base-white
  border: '#bfc4c8',
  // neutrals.15   cosmos neutral medium // neutral-150
  white: '#fcfdfd',
  // neutrals.22 // base-white
  black: '#001122',
  // neutrals.0 // base-black
  gray: {
    dark: '#292A2D' // chrome default title tooltip back ground
  },
  chart: {
    __default: '#f28f20',
    highlight: {
      '1': '#669BD1',
      '2': '#2186a5',
      '3': '#7db654',
      '4': '#fde11f',
      '5': '#1e3a6f',
      '6': '#733d94',
      '7': '#d2232a'
    }
  },
  legend: {
    __default: '#0054A6',
    // blue-700
    highlight: {
      '1': '#183969',
      // blue-900
      '2': '#cf0201',
      '3': '#59942a',
      '4': '#017b30',
      '5': '#ffb400',
      '6': '#fff7e6',
      '7': '#ff850f',
      '8': '#fde11f',
      '9': '#614488',
      '10': '#a8e3da',
      '11': '#00a88c',
      '12': '#669bd1',
      '13': '#4f95d4',
      '14': '#b39ccd',
      '15': '#ab8fcf',
      '16': '#8768ab',
      '17': '#bfbfbf',
      '18': '#a37200',
      '19': '#4ca0fa',
      '20': '#1e3a6f'
    }
  },
  background: 'transparent',
  'white-bg': '#fcfdfd',
  // base-white
  danger: '#d9291c',
  // error.0  cosmos red // red-550
  success: '#1d723f',
  // successes.0   cosmos green // green-700
  warning: '#ffc847',
  // highlights.0  cosmos yellow // yellow-350
  'app-background': '#f2f3f4',
  // neutral.lighter // neutral-25
  'content-background': 'transparent',
  'content-wrapper-background': '#fcfdfd'
}, _baseColors);
var colorOptions = {
  primary: 'Primary',
  'primary.medium': 'Primary Medium',
  'primary.light': 'Primary Light',
  secondary: 'Secondary',
  neutral: 'Neutral',
  'neutral.lighter': 'Neutral Lighter',
  'neutral.light': 'Neutral Light',
  'neutral.medium': 'Neutral medium',
  'neutral.dark': 'Neutral Dark',
  'neutral.darker': 'Neutral Darker',
  muted: 'Muted',
  accent: 'Accent',
  text: 'Text',
  'text.secondary': 'Text Secondary',
  white: 'White',
  black: 'Black',
  'app-background': 'App Background',
  'content-background': 'Content Background',
  'content-wrapper-background': 'Content Wrapper Background'
};
var colorOptionKeys = Object.keys(colorOptions);

export { baseColorPallets, baseColors, colorOptionKeys, colorOptions, colors };
//# sourceMappingURL=colors.esm.js.map
